export function defineInvisibleProperty(obj: object, propertyName: string, value: any) {
	Object.defineProperty(obj, propertyName, {
		enumerable: false,
		configurable: false,
		writable: false,
		value,
	});
}
